// extracted by mini-css-extract-plugin
export default {"title":"question_title__z4nmY","question":"question_question__BasiE","option":"question_option__kFMfZ","checkbox":"question_checkbox__Bt+GO"};